;(() => {
  const isTouch =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    )
  const isIPad = !!(
    navigator.userAgent.match(/iPad/) ||
    (navigator.userAgent.match(/Mac/) &&
      navigator.maxTouchPoints &&
      navigator.maxTouchPoints > 2)
  )

  window.Detector = {
    iPad: isIPad,
    phoneOrTablet: isTouch || isIPad,
    isMobile: window.context === "mobile",
    isDesktop: window.context === "desktop",
  }
})()
